'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isFocus"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { List } from "./List.mjs";
/**
 * PaginationDropdownList is a popover containing PaginationDropdownLinks.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-pagination-paginationdropdownlist--docs) |
 * [Encore site](https://encore.spotify.net/web/components/pagination#pagination-dropdown) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PaginationDropdownList) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12486&t=10cChvdYyvmld0PS-1)
 */
export var PaginationDropdownList = /*#__PURE__*/React.forwardRef(function PaginationDropdownList(_ref, ref) {
  var isFocus = _ref.isFocus,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(List, Object.assign({
    ref: ref,
    role: "listbox",
    $isUsingKeyboard: isUsingKeyboard,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    tabIndex: -1,
    $isFocus: isFocus
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.PaginationDropdownList
  }));
});